

import { Box } from '@mui/system'
import React, { useState } from 'react'
import { Typography, Grid, Divider, Accordion, AccordionSummary, AccordionDetails } from '@mui/material';
import './style.scss'
import { useDispatch, useSelector } from 'react-redux';

import { withStyles } from '@mui/styles';
import VehicleCard from './VehicleCard';
import { BOOKING_INPUT, COUPON_VERIFY_FAIL } from '../Redux/constants/bookingConstants';
import { isEmpty } from 'lodash';
import { useNavigate } from 'react-router-dom';
import BorderBox from './BorderBox';

const AddedVehicle = ({ page }) => {

    const dispatch = useDispatch()
    const navigate = useNavigate()

    

    const { user } = useSelector(state => state.auth)

    const { selectedBooking: booking, currentVehicle: data, bookingType } = useSelector(state => state.booking)
    const { orderData, selectedService, retselectedService} = useSelector(state => state.booking)


    const deleteBooking = (index) => {
        let orderDatas = orderData.filter((or, i) => i !== index)
        dispatch({
            type: BOOKING_INPUT,
            payload: {
                prop: 'orderData',
                value: orderDatas
            }
        })



        if (orderDatas?.length === 0 && isEmpty(booking)) {
            if (user) {
                navigate('/newbooking')
            }
            else {
                navigate('/')
            }

        }
    }

    return (
        <BorderBox title={"Itinerary"}>
           
            <div style={{  }}>
                {orderData && orderData?.map((order, index) => (
                    <VehicleCard
                        mode="order"
                        deleteBooking={() => {
                            deleteBooking(index)
                            dispatch({
                                type: COUPON_VERIFY_FAIL
                            })
                        }}
                        booking={order?.booking_data}
                        edit={'edit'} del={'del'}
                        data={order}
                        bookingType={order?.bookingType}
                        trip={index + 1}
                    />
                ))}
                {booking && <VehicleCard mode="current" booking={booking} data={data} bookingType={bookingType} trip={orderData && orderData.length > 0 ? orderData?.length + 1 : 1} services={selectedService} returnservices={retselectedService} />}
               
            </div>
        </BorderBox>
    )
}

export default AddedVehicle